import { Radio } from "@mantine/core";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type ContractOption = { id: number; description: string };

type Props = {
  form: any;
  contractTypes?: ContractOption[];
};

const DEFAULT_CONTRACT_TYPES: ContractOption[] = [
  { id: -1, description: "Convenio de prácticas" },
  { id: -2, description: "Contrato o vínculo laboral a plazo fijo (tiene fecha de vencimiento)" },
  { id: -3, description: "Contrato o vínculo laboral a plazo indeterminado o indefinido (no vence)" },
];

const Component = ({ form, contractTypes }: Props) => {
  const { t } = useTranslation();

  const options =
    contractTypes && contractTypes.length > 0
      ? contractTypes
      : DEFAULT_CONTRACT_TYPES;

  return (
    <RadioSurvey
      label={t("contract.select")}
      {...form.getInputProps("IL_001_contrato")}
    >
      {options.map((option) => (
        <Radio
          key={option.id}
          label={option.description}
          value={option.description}
        />
      ))}
    </RadioSurvey>
  );
};

export default Component;
